import { render, staticRenderFns } from "./ScreenReaderBtn.vue?vue&type=template&id=08fdae5a&scoped=true&"
import script from "./ScreenReaderBtn.vue?vue&type=script&lang=js&"
export * from "./ScreenReaderBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fdae5a",
  null
  
)

export default component.exports